<template>
  <div class="reveil-countdown" v-if="this.time">
    <span class="monospace-digit"v-for="(char) in this.time.split('')">{{char}}</span>
  </div>
</template>

<script>
import scTime from '@/util/sc_time';

export default {
  name: 'Timer',
  props: ['startTime', 'endTime'],
  data() {
    return {
      time: this.time,
    };
  },
  mounted() {
    this.interval = setInterval(() => {
      this.updateTime();
    }, 1000);
    this.updateTime();
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    updateTime() {
      const secsNow = scTime({ startTime: this.startTime, endTime: this.endTime });
      const secondsUntilEnd = this.endTime - secsNow - 3600;
      
      if (secondsUntilEnd < 0) {
        this.time = '/ +1hr';
        return;
      }
      const hours = Math.floor(secondsUntilEnd / 60 / 60);
      const minutes = Math.floor(secondsUntilEnd / 60) - (hours * 60);
      const seconds = secondsUntilEnd % 60;

      if (!isNaN(hours) && !isNaN(minutes) && !isNaN(seconds)) {
        this.time = '/ '+[hours, minutes, seconds].map(n => (n < 10 ? `0${n}` : n)).join(':');
      }
      else {
        this.time = "/ 00:00:00";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Countdown.vue